import { http } from "../../../config/HttpMethod";
import { JETLIFT_ENDPOINTS } from "../../../store/jetlift/endpoints";
import { StatFldChangePayload, cableRequestParams, cableResponse } from "../../../store/model/calculations/calculation";
import { FlopPayload, ReserPresPayload, inflowOutput } from "../../../store/model/calculations/fluid";

export const getFlopValue = async (payload: FlopPayload) => {
    try {
        const response = await http.post<number>(`${JETLIFT_ENDPOINTS?.GET_FLOP_VALUE}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};
export const getReserPrevChange = async (payload: ReserPresPayload) => {
    const params = {
        ResvPres: payload?.ResvPres,
        CombSpGr: payload?.CombSpGr,
        InUnit: payload?.InUnit,
        OutUnit: payload?.OutUnit,
        Perftn: payload?.Perftn,
        PerftnUnit: payload?.PerftnUnit,
        CasingPressure: payload?.CasingPressure,
        CasingPressureUnit: payload?.CasingPressureUnit,
    };
    try {
        const response = await http.get<number>(`${JETLIFT_ENDPOINTS?.GET_RESV_PRESR_CHANGE}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};
export const getGetStatFldChange = async (payload: StatFldChangePayload) => {
    const params = {
        StacFld: payload?.StacFld,
        CombSpGr: payload?.CombSpGr,
        InUnit: payload?.InUnit,
        OutUnit: payload?.OutUnit,
        Perftn: payload?.Perftn,
        PerftnUnit: payload?.PerftnUnit,
        CasingPressure: payload?.casingPressure,
        CasingPressureUnit: payload?.casingPressureUnit,
    };
    try {
        const response = await http.get<number>(`${JETLIFT_ENDPOINTS?.GET_STATIC_FLUID_CHANGE}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};
export const getInflowCalculations = async (payload: object) => {
    try {
        const response = await http.post<inflowOutput>(`${JETLIFT_ENDPOINTS?.GET_INFLOW_CALCULATIONS}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

